import cart from '@ppcp/cart';
import {FastlaneCheckout} from "../payments/classes/class-fastlane-checkout";

const fastlane = new FastlaneCheckout({
    cart,
    settings: wc_ppcp_fastlane_params
});

fastlane.initialize();